<template>
    <div id="bindWeixin">
        <div class="link">
            <router-link v-if="user.rebind=='1'" to="/user/setting">&lt;返回账户设置</router-link>
            <router-link v-if="user.rebind!='1'" to="/portal">&lt;返回登录页</router-link>
        </div>
        <div class="bindWeixin-title">微信绑定</div>
        <div class="headerImg">
            <img :src="user.headimgurl" alt=""> &nbsp;&nbsp;
            <span>Hi,{{user.nickname}}
            </span>
        </div>
        <div class="bindWeixin-text">请输入易比得账号和密码，完成与微信的绑定。 下次登录时，即可使用微信扫码登录。</div>
        <el-form :model="user" :rules="rules" ref="bindWeixin">
            <el-form-item prop="username">
                <el-input v-model="user.userName" placeholder="请输入手机号" class="eb-input">
                    <i slot="prepend" class="icon iconfont icon-shouji"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" v-model="user.userPassword" placeholder="请输入密码" class="eb-input">
                    <i slot="prepend" class="icon iconfont icon-mima"></i>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button id="loginBtn" class="eb-button-orange" @click="submitForm('bindWeixin')">绑定并登录</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { getWxBindInfoByStoreKey, wxBind } from '@/services/weixin-service';
export default {
  name: 'bindWeixin',
  data() {
    return {
      user: {},
      rules: {
        username: [{ validator: this.checkUserName, trigger: 'blur' }],
        password: [{ validator: this.checkPassWord, trigger: 'blur' }]
      }
    };
  },
  created() {
    this.$root.layout.isShowTop = false;
    this.$root.layout.isShowNav = false;
    this.$root.layout.isShowAside = false;
    this.$root.layout.isShowHeader = false;
    this.$root.layout.isShowBottom = false;
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getWxBindInfoByStoreKey(this.$route.params.storeKey);
        if (data.returnCode === '01') {
          this.user = data;
        } else {
          this.$message.error(data.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.wxBindService();
        } else {
          return false;
        }
      });
    },
    async wxBindService() {
      let params = {
        rebind: this.user.rebind,
        nickname: this.user.nickname,
        headimgurl: this.user.headimgurl,
        openid: this.user.openid,
        unionid: this.user.unionid,
        userName: this.user.userName,
        userPassword: this.user.userPassword
      };
      try {
        let { data } = await wxBind(params);
        if (data.returnCode === '01') {
          this.$store.dispatch('setLoginType', 'wx');
          this.$store.dispatch('changeUserRole', data.user.roleid);
        } else {
          this.$message.error('用户名或密码不正确！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    checkUserName: function(rule, value, callback) {
      this.user.userName = ('' + this.user.userName).replace(/\s/g, '');
      if (!this.user.userName) {
        return callback(new Error('请输入用户名'));
      }
      if (!parseInt(this.user.userName)) {
        return callback(new Error('请输入正确手机号'));
      }
      this.user.userName = parseInt(this.user.userName);
      if (('' + this.user.userName).length !== 11) {
        return callback(new Error('请输入11位手机号'));
      }
      callback();
    },
    checkPassWord: function(rule, value, callback) {
      this.user.userPassword = ('' + this.user.userPassword).replace(/\s/g, '');
      if (!this.user.userPassword) {
        return callback(new Error('请输入密码'));
      }
      callback();
    }
  }
};
</script>
<style lang="less">
#bindWeixin {
  width: 330px;
  margin: 0 auto;
  padding-top: 30px;
  .link {
    a {
      color: #337ab7;
    }
  }
  .bindWeixin-title {
    padding: 10px 0;
    font-size: 30px;
    font-weight: 500;
  }
  .headerImg {
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .bindWeixin-text {
    padding: 10px 0;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 9px;
    background: #f8f7f8;
  }
  .el-input__inner {
    height: 45px;
  }
  .eb-button-orange {
    height: 45px;
  }
}
</style>
